import {
  GameMode,
  isGameModeBsg,
  isGameModeCornucopia,
} from '../../utils/constants';

// Each deck has its own sprite sheet, and the card ids overlap between decks
// (BSG's Spoofing card D2 is not the EoP card D2), so every deck but the
// default one namespaces its classes.
export function getCardClassName(gameMode: GameMode, card: string): string {
  const suffix = card.toLowerCase();

  if (isGameModeCornucopia(gameMode)) {
    return `cornucopiacard ccard${suffix}`;
  }

  if (isGameModeBsg(gameMode)) {
    return `bsgcard bcard${suffix}`;
  }

  return `card${suffix}`;
}
